import React from 'react';
import styled from 'styled-components';
import { Header } from '@app/navigation/header';
import { Body } from '@ui';
import { scrollToTop } from '@utils/usefulFuncs';
import { sendApiRequest } from '@services/api';

const PageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

function EconomicImpact() {
  React.useEffect(() => {
    const init = async () => {
      const URL = `v1/genai/documents?category=user&speaker_query_string=pow`;
      const { status, data, error } = await sendApiRequest('get', URL);
    };
    init();
    scrollToTop();
  }, []);

  return (
    <PageWrapper>
      <Header />
      <Body withFooter>{/*<DocumentsSnapshotTool onGoBack={onGoBack} />*/}</Body>
    </PageWrapper>
  );
}

export default EconomicImpact;
